import { Body } from '@panwds/react-ui'
import { Line } from '../../../../common/assets/images'

const CIESharingTsgRenderer = ({ row, ...rest }) => {
  const { displayName = '', level = 1 } = row?.original

  return <div style={{ marginLeft: `${level * 25}px` }} className='cm-flex cm-flex-row'>
    {!!level && <img style={{ width: '10px', height: '10px' }} src={Line} alt={'line'} />}
    <div className='cm-pl-1'><Body size='sm'>{displayName}</Body></div>
  </div>
}
export default CIESharingTsgRenderer

